import { Button, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@estac1/ui';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Fragment } from 'react';
import type { AuditEntry } from './types.js';
import { formatAt, hasDiff } from './utils.js';

interface AuditDesktopTableProps {
  entries: AuditEntry[];
  expanded: Set<string>;
  onToggle: (id: string) => void;
}

export const AuditDesktopTable = ({ entries, expanded, onToggle }: AuditDesktopTableProps) => (
  <div className="hidden overflow-x-auto md:block">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-8" />
          <TableHead>Quando</TableHead>
          <TableHead>Ator</TableHead>
          <TableHead>Ação</TableHead>
          <TableHead>Entidade</TableHead>
          <TableHead>ID</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {entries.map((e) => {
          const canExpand = hasDiff(e.diff);
          const isOpen = expanded.has(e.id);
          return (
            <Fragment key={e.id}>
              <TableRow>
                <TableCell className="p-1">
                  {canExpand ? (
                    <Button
                      variant="ghost"
                      size="icon"
                      aria-label={isOpen ? 'Recolher detalhes' : 'Ver detalhes'}
                      onClick={() => onToggle(e.id)}
                    >
                      {isOpen ? (
                        <ChevronDown className="h-4 w-4" />
                      ) : (
                        <ChevronRight className="h-4 w-4" />
                      )}
                    </Button>
                  ) : null}
                </TableCell>
                <TableCell className="font-mono text-xs">{formatAt(e.at)}</TableCell>
                <TableCell className="text-sm">
                  {e.actorEmail ?? `${e.actorType}/${e.id.slice(0, 8)}`}
                </TableCell>
                <TableCell className="font-mono text-xs">{e.action}</TableCell>
                <TableCell className="font-mono text-xs">{e.entity}</TableCell>
                <TableCell className="truncate font-mono text-xs">{e.entityId ?? '—'}</TableCell>
              </TableRow>
              {isOpen && canExpand && (
                <TableRow>
                  <TableCell colSpan={6} className="bg-muted/40 p-3">
                    <pre className="overflow-x-auto whitespace-pre-wrap break-all font-mono text-xs">
                      {JSON.stringify(e.diff, null, 2)}
                    </pre>
                  </TableCell>
                </TableRow>
              )}
            </Fragment>
          );
        })}
      </TableBody>
    </Table>
  </div>
);
